var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 12.75C0.75 6.95101 5.45101 2.25 11.25 2.25V12.75L19.7949 18.8535C17.8902 21.5153 14.7727 23.25 11.25 23.25C5.45101 23.25 0.75 18.549 0.75 12.75ZM2.25 12.7501C2.25 8.29058 5.49343 4.58863 9.75 3.87451V13.5001L17.6121 19.1159C15.9836 20.7435 13.7343 21.7501 11.25 21.7501C6.27944 21.7501 2.25 17.7206 2.25 12.7501Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 0.75V9.75H23.1438C22.4158 4.66154 18.0396 0.75 12.75 0.75ZM14.25 2.25V8.25H21C20.6848 5.70577 16.5401 2.25 14.25 2.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2203 17.6028C23.0327 15.9929 23.25 13.5 23.25 11.25H12.75L21.2203 17.6028Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormat);
export default __webpack_public_path__ + "static/media/format.5759913c26ef98cc9c1bc8811abe4cd8.svg";
export { ForwardRef as ReactComponent };